import { Directive, HostListener } from '@angular/core';

// Máscara dd/mm/aaaa para digitação manual em campos de data
@Directive({
  selector: 'input[appDateMask]',
  standalone: false
})
export class DateMaskDirective {

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const numbers = (input.value || '').replace(/\D/g, '').slice(0, 8);

    let masked = numbers;
    if (numbers.length > 4) {
      masked = `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4)}`;
    } else if (numbers.length > 2) {
      masked = `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    }

    if (masked !== input.value) {
      input.value = masked;
    }
  }
}
